// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ua-reels-profile-container {
  flex: 3 1;
  flex-direction: row;
  display: flex;
  flex-wrap: nowrap; /* Prevent wrapping to new lines */
  white-space: nowrap; /* Prevent text from breaking */
  background: none;
  height: 100%;
  width: 100%;
  gap: 20px;
  overflow: hidden;
  border-radius: 10px;
}

.reels-profile-section {
    width: 100%;
    /* overflow-y: auto; */
    background: #f4f4f4;
    border-radius: 10px;
    border-color: white; 
    height: 10px;   
    display: flex;
    padding: 15px;
    flex-direction: column;
    border-right: 1px solid #ddd;
    gap: 5px;
    margin-top: 10;

  }

/* Left Panel Container */
.reels-profile-list {
    width: 70%;
    height: 200vh;
    background: none;
    display: flex;
    flex-direction: column;
    border-right: 1px solid #ddd;
    padding: 10px;
    border-radius: 10px;
    border-width: 10px;
    gap: 20px;
    /* border: 1px solid black; */
  }

  .reels-profile-list-container {
    padding: 10px;
    margin-left: 30px;
    display: flex;
    flex-direction: row;
    gap:20;
  }
  
  /* Profile Section - Fixed at the Top */
  .reels-profile-section {
    position: sticky;
    top: 0;
    z-index: 10;
    background: #fff;
    padding: 15px;
    display: flex;
    align-items: center;
    height: 100px;
    border-bottom: 1px solid #030202;
    border: 1px solid rgb(11, 4, 4);
    border-radius: 10px;
  }
  
  /* Profile Picture */
  .reels-profile-pic {
    width: 50px;
    height: 50px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 10px;
  }
  
  /* User Name */
  .reels-profile-name {
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }
  

  /* Friend Avatar */
  .reels-friend-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 10px;
  }
  
  /* Friend Name */
  .reels-friend-name {
    font-size: 14px;
    flex-grow: 1;
  }
  
  /* Message Button */
  .reels-message-button {
    background: none;
    color: #fff;
    border: none;
    padding: 5px 5px;
    border-radius: 1px;
    cursor: pointer;
  }
  
  .reels-message-button:hover {
    background: none;
  }
  

/* Left Panel Container */
.left-panel {
    width: 25%;
    height: 100%;
    min-height: 1000px;
    border-right: 1px solid #e5e7eb;
    background-color: #f3f4f6;
    padding: 16px;
    display: flex;
    flex-direction: column;
  }
  
  /* Header */
  .left-panel h2 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #374151;
    margin-bottom: 16px;
  }
  
  /* User Profile Section */
  .user-profile {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 24px;
  }
  
  .user-profile img {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    object-fit: cover;
  }
  
  .user-profile span {
    font-size: 1rem;
    font-weight: 500;
    color: #1f2937;
  }
  
  /* Profile List */
  .profile-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }
  
  .profile-list li {
    padding: 10px;
    border-radius: 6px;
    font-size: 1rem;
    color: #4b5563;
    cursor: pointer;
    transition: background 0.2s ease-in-out, font-weight 0.2s;
  }
  
  .profile-list li:hover {
    background-color: #e5e7eb;
  }
  
  .profile-list li.selected {
    background-color: #d1d5db;
    font-weight: 600;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Pages/AccountPage/Components/Reels/Styles/ReelsGridTopLayout.css"],"names":[],"mappings":"AAAA;EACE,SAAO;EAEP,mBAAmB;EACnB,aAAa;EACb,iBAAiB,EAAE,kCAAkC;EACrD,mBAAmB,EAAE,+BAA+B;EACpD,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;IACI,WAAW;IAEX,sBAAsB;IACtB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,4BAA4B;IAC5B,QAAQ;IACR,cAAc;;EAEhB;;AAEF,yBAAyB;AACzB;IACI,UAAU;IACV,aAAa;IACb,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,6BAA6B;EAC/B;;EAEA;IACE,aAAa;IACb,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,MAAM;EACR;;EAEA,uCAAuC;EACvC;IACE,gBAAgB;IAChB,MAAM;IACN,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,gCAAgC;IAChC,+BAA+B;IAC/B,mBAAmB;EACrB;;EAEA,oBAAoB;EACpB;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,cAAc;EACd;IACE,eAAe;IACf,iBAAiB;IACjB,WAAW;EACb;;;EAGA,kBAAkB;EAClB;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA,gBAAgB;EAChB;IACE,eAAe;IACf,YAAY;EACd;;EAEA,mBAAmB;EACnB;IACE,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;;AAGF,yBAAyB;AACzB;IACI,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,+BAA+B;IAC/B,yBAAyB;IACzB,aAAa;IACb,aAAa;IACb,sBAAsB;EACxB;;EAEA,WAAW;EACX;IACE,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;EACrB;;EAEA,yBAAyB;EACzB;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,wCAAwC;IACxC,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,cAAc;EAChB;;EAEA,iBAAiB;EACjB;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;EACX;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,eAAe;IACf,yDAAyD;EAC3D;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;EAClB","sourcesContent":[".ua-reels-profile-container {\n  flex: 3;\n  display: flex;\n  flex-direction: row;\n  display: flex;\n  flex-wrap: nowrap; /* Prevent wrapping to new lines */\n  white-space: nowrap; /* Prevent text from breaking */\n  background: none;\n  height: 100%;\n  width: 100%;\n  gap: 20px;\n  overflow: hidden;\n  border-radius: 10px;\n}\n\n.reels-profile-section {\n    width: 100%;\n    height: 30px;\n    /* overflow-y: auto; */\n    background: #f4f4f4;\n    border-radius: 10px;\n    border-color: white; \n    height: 10px;   \n    display: flex;\n    padding: 15px;\n    flex-direction: column;\n    border-right: 1px solid #ddd;\n    gap: 5px;\n    margin-top: 10;\n\n  }\n\n/* Left Panel Container */\n.reels-profile-list {\n    width: 70%;\n    height: 200vh;\n    background: none;\n    display: flex;\n    flex-direction: column;\n    border-right: 1px solid #ddd;\n    padding: 10px;\n    border-radius: 10px;\n    border-width: 10px;\n    gap: 20px;\n    /* border: 1px solid black; */\n  }\n\n  .reels-profile-list-container {\n    padding: 10px;\n    margin-left: 30px;\n    display: flex;\n    flex-direction: row;\n    gap:20;\n  }\n  \n  /* Profile Section - Fixed at the Top */\n  .reels-profile-section {\n    position: sticky;\n    top: 0;\n    z-index: 10;\n    background: #fff;\n    padding: 15px;\n    display: flex;\n    align-items: center;\n    height: 100px;\n    border-bottom: 1px solid #030202;\n    border: 1px solid rgb(11, 4, 4);\n    border-radius: 10px;\n  }\n  \n  /* Profile Picture */\n  .reels-profile-pic {\n    width: 50px;\n    height: 50px;\n    border-radius: 50%;\n    object-fit: cover;\n    margin-right: 10px;\n  }\n  \n  /* User Name */\n  .reels-profile-name {\n    font-size: 16px;\n    font-weight: bold;\n    color: #333;\n  }\n  \n\n  /* Friend Avatar */\n  .reels-friend-avatar {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    object-fit: cover;\n    margin-right: 10px;\n  }\n  \n  /* Friend Name */\n  .reels-friend-name {\n    font-size: 14px;\n    flex-grow: 1;\n  }\n  \n  /* Message Button */\n  .reels-message-button {\n    background: none;\n    color: #fff;\n    border: none;\n    padding: 5px 5px;\n    border-radius: 1px;\n    cursor: pointer;\n  }\n  \n  .reels-message-button:hover {\n    background: none;\n  }\n  \n\n/* Left Panel Container */\n.left-panel {\n    width: 25%;\n    height: 100%;\n    min-height: 1000px;\n    border-right: 1px solid #e5e7eb;\n    background-color: #f3f4f6;\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  /* Header */\n  .left-panel h2 {\n    font-size: 1.25rem;\n    font-weight: 600;\n    color: #374151;\n    margin-bottom: 16px;\n  }\n  \n  /* User Profile Section */\n  .user-profile {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px;\n    background-color: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n    margin-bottom: 24px;\n  }\n  \n  .user-profile img {\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    object-fit: cover;\n  }\n  \n  .user-profile span {\n    font-size: 1rem;\n    font-weight: 500;\n    color: #1f2937;\n  }\n  \n  /* Profile List */\n  .profile-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n  }\n  \n  .profile-list li {\n    padding: 10px;\n    border-radius: 6px;\n    font-size: 1rem;\n    color: #4b5563;\n    cursor: pointer;\n    transition: background 0.2s ease-in-out, font-weight 0.2s;\n  }\n  \n  .profile-list li:hover {\n    background-color: #e5e7eb;\n  }\n  \n  .profile-list li.selected {\n    background-color: #d1d5db;\n    font-weight: 600;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
